module.exports = __webpack_public_path__ + "img/sampleGraph3.bf474948.png";